import { render, staticRenderFns } from "./EventAttendeesList.vue?vue&type=template&id=2d4196ff&scoped=true"
import script from "./EventAttendeesList.vue?vue&type=script&lang=js"
export * from "./EventAttendeesList.vue?vue&type=script&lang=js"
import style0 from "./EventAttendeesList.vue?vue&type=style&index=0&id=2d4196ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4196ff",
  null
  
)

export default component.exports